import React from "react";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { get } from "lodash";

import Collapse from "Components/Common/ViewApplicationDetailComponents/Collapse";
import { getOptionLabel } from "common/enums";

const ViewConsumerLoadDetails = ({
  title,
  loadDetails = {},
  t,
  isExpandable = true,
}) => {
  const {
    backupPower,
    consumerNumber,
    contractLoad,
    electricityDuty,
    greenPower,
    loadDetails: currentLoadDetails,
    securityDeposit,
    supplyVoltage,
    premiseTypeName,
    tariffId,
  } = loadDetails;

  const fields = [
    {
      name: "Consumer Number",
      key: "consumerNumber",
      isVisible: !!consumerNumber,
      isRequired: true,
    },
    {
      name: "Security Deposit",
      key: "securityDeposit",
      isVisible: !!securityDeposit || securityDeposit === 0,
      isRequired: true,
    },
    {
      name: "Electricity Duty",
      key: "electricityDuty",
      isVisible: !!electricityDuty || electricityDuty === 0,
      isRequired: true,
    },
    {
      name: "Tariff",
      key: "tariffId",
      isRequired: false,
      isVisible: !!tariffId,
      renderField: (val) => getOptionLabel("tariff", val) || "-",
    },
    {
      name: "Premise Type",
      key: "premiseTypeName",
      isVisible: !!premiseTypeName,
      isRequired: true,
    },
    {
      name: "Backup Power",
      key: "backupPower",
      isVisible: !!backupPower || backupPower === 0,
      isRequired: false,
      renderField: (val) => (val ? `${val} kVA` : "N/A"),
    },
    {
      name: "Load Details",
      key: "loadDetails",
      isVisible: !!currentLoadDetails,
      isRequired: true,
      renderField: (value) => getOptionLabel("loadOptions", value) || "-",
    },
    {
      name: "Contract Load",
      isVisible: !!contractLoad,
      key: "contractLoad",
      isRequired: true,
    },
    {
      name: "Supply Voltage",
      key: "supplyVoltage",
      isVisible: !!supplyVoltage,
      isRequired: true,
    },
    {
      name: "Green Power",
      key: "greenPower",
      isVisible: !!greenPower || greenPower === 0,
      isRequired: false,
      renderField: (value) => (value ? `${value} %` : "No"),
    },
  ];

  return (
    <Collapse title={title} isExpandable={isExpandable}>
      <Row className="d-flex mb-2">
        {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
          const value = get(loadDetails, key, "");
          if (typeof isVisible !== "boolean" || isVisible) {
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(loadDetails, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          }
        })}
      </Row>
    </Collapse>
  );
};

ViewConsumerLoadDetails.propTypes = {
  loadDetails: PropTypes.object,
  t: PropTypes.object,
  isExpandable: PropTypes.bool,
  title: PropTypes.string,
};

export default withTranslation()(ViewConsumerLoadDetails);
